export var logMap = {
    perf: {
        fp: "p1",
        fcp: "p2",
        lcp: "p3",
        startTime: "p4",
        unloadEventStart: "p5",
        unloadEventEnd: "p6",
        redirectStart: "p7",
        redirectEnd: "p8",
        fetchStart: "p9",
        domainLookupStart: "p10",
        domainLookupEnd: "p11",
        connectStart: "p12",
        secureConnectionStart: "p13",
        connectEnd: "p14",
        requestStart: "p15",
        responseStart: "p16",
        responseEnd: "p17",
        domInteractive: "p18",
        domContentLoadedEventStart: "p19",
        domContentLoadedEventEnd: "p20",
        domComplete: "p21",
        loadEventStart: "p22",
        loadEventEnd: "p23"
    },
    error: {
        // 转化
        file: "p1",
        lineno: "p2",
        colno: "p3",
        stack: "p4",
        errType: "p5",
        errCode: "p6",
        stack1: "p7",
        stack2: "p8",
        stack3: "p9"
    },
    api: {
        api: "p1",
        success: "p2",
        httpCode: "p3",
        code: "p4",
        time: "p5",
        traceId: "p6",
        params: "p7",
        response: "p8",
        header: "p9",
        requestType: "p10",
        method: "p11",
        /**
     * 业务处理是否成功
     */ bizSuccess: "p12",
        /**
     * 业务额外上报参数对象
     */ bizExtParams: "p13",
        /**
     * response是否符合菜鸟前后端数据规范
     */ responseIsMatchSpecification: "p14",
        /**
     * 服务端执行时间
     */ serverExecTime: "p15",
        /**
     * serverTime对象
     */ serverTiming: "p16",
        /**
     * errorMsg被读取的次数
     */ errorMsgUseCount: "p17",
        /**
     * timeZone api请求时区
     */ timeZone: "p18",
        // aserver ip
        aserverIp: "p19",
        /**
     * requestSize api请求request中body的体积
     */ requestSize: "p20",
        /**
     * responseSize api请求response中data的体积
     */ responseSize: "p21",
        longTaskCount: "p22",
        /**
     * sse接口返回第一个token的时间
     */ firstTokenTime: "p23"
    },
    event: {
        id: "p1",
        eventType: "p2",
        xpath: "p3",
        success: "p4",
        time: "p5"
    },
    form: {
        formKey: "p1",
        feature: "p2",
        errors: "p3",
        status: "p4",
        fieldId: "p5",
        fieldLabel: "p6",
        url: "p7",
        submitCount: "p8",
        totalTime: "p9",
        pureTime: "p10",
        leaveTime: "p11",
        leaveCount: "p12",
        idleTime: "p13",
        idleCount: "p14",
        uuid: "p15",
        comps: "p16"
    },
    // 自定义测速
    speed: {
        t1: "p1",
        t2: "p2",
        t3: "p3",
        t4: "p4",
        t5: "p5",
        t6: "p6",
        t7: "p7",
        t8: "p8",
        t9: "p9",
        t10: "p10"
    },
    // 自定义统计(求和/求均值)
    calc: {
        method: "p1",
        key: "p2",
        value: "p3"
    },
    // 流程行为
    action: {
        action: "p3",
        actionType: "p4",
        result: "p5",
        actionCode: "p6",
        description: "p7",
        duration: "p8"
    },
    runtime: {
        // 用户停留时长
        stayTime: "p1",
        // 静态资源缓存命中率
        cacheUseRate: "p2",
        // 页面点击次数
        clickTimes: "p3",
        // 最大dom节点数
        maxNodesCount: "p4",
        // 响应延迟记录列表
        eventResponseDelayList: "p5",
        // 响应延迟发生次数
        eventResponseDelayTimes: "p6",
        // 卡顿记录列表
        longTaskList: "p7",
        // 卡顿发生次数
        longTaskTimes: "p8",
        // 表格记录 [ {xpath: 'table', columns: 10} ]
        tables: "p9",
        // 滚屏次数
        scrollPageTimes: "p10",
        // 体积大于500K的静态资源文件列表
        bigFiles: "p11",
        // 列多于10个的表格数量
        bigTableCount: "p12",
        firstScrollScreenTime: "p13",
        pageHeightRatio: "p14",
        horizontalScrollTimes: "p15",
        firstScreenClickRate: "p16",
        clickDetail: "p17",
        // 页面加载的js文件列表
        jsFiles: "p18"
    },
    /**
   * 网页加载性能
   */ performance: {
        /**
     * performance.timing的数据：json格式
     */ timing: "p1",
        /**
     * fcp或domInteractive耗时
     */ fcp: "p2",
        /**
     * lcp或totalTime
     */ lcp: "p3",
        /**
     * 服务端获取VM的执行时间
     */ serverExecTime: "p4",
        /**
     * dns查询耗时
     */ dnsTime: "p5",
        /**
     * 首字节传输时间
     */ ttfb: "p6",
        /**
     * dom complete时间
     */ domComplete: "p7",
        /**
     * dom加载总耗时
     */ totalTime: "p8",
        /**
     * js、css文件加载耗时超过1秒的文件个数
     */ slowLoadResourceCount: "p9",
        /**
     * js和css文件加载时的缓存命中率
     */ cacheUseRate: "p10",
        /**
     * 其他额外信息：格式为json
     */ extendInfo: "p11"
    },
    bizFlow: {
        // 业务流程id
        id: "p1",
        // 业务流程步骤名称
        step: "p2",
        // 业务流程步骤开始时间的时间戳
        startTime: "p3",
        // 业务流程traceId, 用于串联整个业务流程
        traceId: "p4",
        // 业务流程步骤耗时
        duration: "p5",
        // 业务流程执行到当前步骤结束的总耗时
        totalDuration: "p6",
        // 业务流程步骤是否是最后一步
        isLastStep: "p7",
        // 业务流程步骤是否成功
        success: "p8",
        // 业务流程步骤失败原因
        failReason: "p9",
        // 业务流程步骤额外参数
        extParams: "p20"
    },
    // 无痕埋点
    autoAction: {
        logtype: "p1",
        className: "p2",
        customPath: "p3",
        container: "p4",
        feature: "p5",
        text: "p6",
        xpath: "p7",
        placeholder: "p8",
        clk: "p9",
        exp: "p10",
        whole: "p11",
        extra: "p12",
        systemMergePath: "p13",
        systemMergeText: "p14"
    },
    // AB测试
    abTest: {
        id: "p1",
        success: "p2",
        time: "p3",
        failReason: "p4",
        bizInfo: "p5"
    },
    // 统计前端页面文案
    pageText: {
        componentType: "p1",
        feedbackType: "p2",
        message: "p3"
    }
};
export default logMap;

 //# sourceMappingURL=log-map.js.map